import React from 'react';
import { format } from 'date-fns';

import About from 'components/Meteorology/Agro/About';
import DVCardMobileLayout from 'components/Meteorology/Agro/WaterBalanceShared/DVCardMobileLayout';
import useDetailedViewMobile from 'hooks/Meteorology/Agro/WaterBalanceSequential/DetailedView/Mobile/useDetailedViewMobile';
import { formatRunDateChip } from 'helper/Meteorology/Agro/chartSubtitle';
import ChartDisplay from '../ChartDisplay';
import ControlPanelSheet from './ControlPanelSheet';
import EmptyState from './EmptyState';
import FullscreenChart from './FullscreenChart';

const COMPONENTS = {
  Chart: ChartDisplay,
  Fullscreen: FullscreenChart,
  About,
  ControlPanelSheet,
  EmptyState,
};

export default function DetailedViewCardMobile() {
  const {
    location, period, soil, chartVariable, params,
    graphData, runDate, graphDataLoading, queryError, onRetry,
  } = useDetailedViewMobile();

  const selectedLocationName = location.locationOptions
    .find((l) => l.id === location.selectedLocation)?.name;
  const selectedSoilLabel = soil.soilTypes.find((s) => s.id === soil.selectedSoil)?.label;

  const chips: string[] = [];
  if (period.startDate && period.endDate) {
    chips.push(`${format(period.startDate, 'dd/MM/yy')} – ${format(period.endDate, 'dd/MM/yy')}`);
  }
  // #2009: a rodada da previsão usada no cálculo; ausente em consulta só histórica.
  const runChip = formatRunDateChip(runDate);
  if (runChip) chips.push(runChip);
  if (selectedSoilLabel) chips.push(`Solo: ${selectedSoilLabel}`);

  return (
    <DVCardMobileLayout
      optionKey="value"
      title={selectedLocationName}
      chips={chips}
      filenamePrefix="balanco_hidrico_sequencial"
      emptyText="Defina grupo, local e período no painel de controle para visualizar o balanço hídrico."
      graphData={graphData}
      graphDataLoading={graphDataLoading}
      hasParams={params !== undefined}
      queryError={queryError}
      onRetry={onRetry}
      chartVariable={chartVariable}
      period={period}
      components={COMPONENTS}
    />
  );
}
